import { Component, Input, Output, EventEmitter, OnChanges, OnInit } from '@angular/core'

import { InsaCronService, LocalizeService } from '../../../../insa-services';
import { ChronosJobListColumnDef } from '../../';
import { ChronosActivitiesModel, InsaChronosJobModel, GenericKendoGridColumnDefinition, ChronosActivityResultActions, } from '../../../../insa-models';

import { appStateProvider } from '../../../../insa-providers';
//import { DOCUMENT } from '@angular/platform-browser';
//import {DOCUMENT} from '@angular/common';
import { customGroupHeader, SharedMethodsModule } from '../../../../insa-custom-scripts';
import { Subject } from 'rxjs';


@Component({
    selector: "insa-chronos-activities",
    template: require("./job-activities.component.html")
})
export class JobActivitiesListComponent implements OnInit, OnChanges {

    _jobID: number = null;
    _activityID: number = null;
    _allJobActivities: Array<ChronosActivitiesModel>;
    _activityTypes: any;

    @Input() activityPostActions: ChronosActivityResultActions;
    @Input() set jobID(jobId: number) { this._jobID = jobId; }
    @Input() set activityID(activityID: number) { this._activityID = activityID; }
    @Input() selectedJobData: InsaChronosJobModel = new InsaChronosJobModel();
    @Input() prioritiesList: Array<Object>;
    @Input() set allJobActivities(alljobactivities: Array<ChronosActivitiesModel>) { this._allJobActivities = alljobactivities; };
    @Input() set activityTypes(actTypes: any) { this._activityTypes = actTypes }
    //@Input() allJobActivites: Array<ChronosActivitiesModel>;
    @Output() EmitNewActivity: EventEmitter<ChronosActivitiesModel[]> = new EventEmitter<ChronosActivitiesModel[]>(true);
    @Output() emitRenderGraphAgain: EventEmitter<any> = new EventEmitter<any>();
    @Output() emitDeleteAndUpdateGraph: EventEmitter<any> = new EventEmitter<any>();
    private deleteAndUpdateGraph: boolean;
    private gridName = 'ChronosJobActivitiesList'

    @Input() mermaidSelectedActivityIDSubject: Subject<number>;

    mermaidVisible: boolean = false;
    @Input() mermaidAddNewActSubject: Subject<boolean>;

    private jobAcitivtiesListSubscription;
    private isJobActivtySelected: boolean = false;
    private isJobActivityForDeleteSelected: boolean = false;
    private isJobActivityAddSelected: boolean = false;
    private isPostActionSelected: boolean = false;
    private selectedActivity: any;
    mermaidAddNewAct: any;
    postActions: any;
    //activityTypes: any;
    activityDataList = [];
    finalActivityDataList = [];
    priorites: Array<Object>;
    newActivities: any;

    constructor(private _insaChronService: InsaCronService, private _appStateProvider: appStateProvider, private _localize: LocalizeService) {

    }

    private refreshActivitiesList(jobActivites: ChronosActivitiesModel[]) {
        if (jobActivites !== undefined && jobActivites !== null && jobActivites.length > 0) {
            this.InitKendoJobActivitiesGrid(this.createJobActivitiesGridColumnDefs(), jobActivites);
        } else {
            this.InitKendoJobActivitiesGrid(this.createJobActivitiesGridColumnDefs(), []);
        }
    }

    private createJobActivitiesGridColumnDefs() {

        let jobActivitiesListColumnDefs = new Array<ChronosJobListColumnDef>();
        let activityTypeColumn: ChronosJobListColumnDef = new ChronosJobListColumnDef("ActivityTypeID", "Type");
        activityTypeColumn.hidden = false;
        //activityTypeColumn.template = undefined;
        if (this._activityTypes !== undefined) {
            activityTypeColumn.values = this._activityTypes.map(function (item) {
                let newData: Object = { text: item.ActivityName, value: item.ActivityTypeID, };
                return newData;
            });
        }

        jobActivitiesListColumnDefs.push(new ChronosJobListColumnDef("ActivityID", "ActivityID", true)); //'#:(ActivityID!==null) ? ActivityID : "" #'
        jobActivitiesListColumnDefs.push(new ChronosJobListColumnDef("JobID", "JobID", true)); //, '#:(JobID!==null) ? JobID : "" #'
        jobActivitiesListColumnDefs.push(activityTypeColumn);
        jobActivitiesListColumnDefs.push(new ChronosJobListColumnDef("Description", "Name")); //, '#: (Description!==null)? Description : ""#')
        //jobActivitiesListColumnDefs.push(new ChronosJobListColumnDef("TriggerOrder", "TriggerOrder", true)); //'#: (TriggerOrder!==null)? TriggerOrder : ""#'))
        //jobActivitiesListColumnDefs.push(new ChronosJobListColumnDef("MaxRepeatCount", "Max Repeat Count")); //, '#: (MaxRepeatCount!==null) ? MaxRepeatCount : "" #')
        //jobActivitiesListColumnDefs.push(new ChronosJobListColumnDef("RepeatDelayMinutes", "Repeat Delay Minutes")); //, '#: (RepeatDelayMinutes!==null) ? RepeatDelayMinutes : "" #')
        return jobActivitiesListColumnDefs;
    }

    getActivity(activityData) {
        this.activityDataList.push(activityData);
        this.finalActivityDataList = [].concat.apply([], this.activityDataList)
        //this.InitKendoJobActivitiesGrid(this.createJobActivitiesGridColumnDefs(), this.finalActivityDataList);
        this.refreshActivitiesList(this.finalActivityDataList);
        this.EmitNewActivity.emit(this.finalActivityDataList);
        this.newActivities = activityData;
    }

    /*getActivityList(activityList) {
        this.InitKendoJobActivitiesGrid(this.createJobActivitiesGridColumnDefs(), activityList);
    }*/

    getPostAction(postActions) {
        this.postActions = postActions;
    }

    private getActivityFromRow(e) {
        e.preventDefault();

        let activityList: kendo.ui.Grid = $("#ChronosJobActivitiesList").data("kendoGrid");
        let tr = $(e.target).closest("tr");

        //get selected button action by Id
        let target = e.target || e.srcElement || e.currentTarget;
        let idAttr = target.attributes.id;
        let actionValue = idAttr.nodeValue;

        switch (actionValue) {
            case "editActivityBtn": {
                this.isJobActivtySelected = true;
                this.selectedActivity = activityList.dataItem(tr);
                break;
            }
            case "deleteActivityBtn": {
                this.isJobActivityForDeleteSelected = true;
                this.selectedActivity = activityList.dataItem(tr);
                this.activityID = this.selectedActivity.ActivityID;
                break;
            }
            case "postActBtn": {
                this.isPostActionSelected = true;
                this.selectedActivity = activityList.dataItem(tr);
                break;
            }
            default: {
                console.log("Invalid choice");
                break;
            }
        }
    }
    
    
     hideModal() {
         this.isJobActivtySelected = false;
         this.isJobActivityForDeleteSelected = false;
         this.isJobActivityAddSelected = false;
         this.isPostActionSelected = false;
         this.mermaidVisible = false;
         console.log("hide_modal");
     }

    isComponentCreated(isCreated) {
        if (this._jobID !== undefined && this._jobID !== null) {
            this._insaChronService.getActivityByJobId(this._jobID).subscribe(d => {
                this._allJobActivities = d,
                    this.EmitNewActivity.emit(this._allJobActivities)
                this.refreshActivitiesList(d)
            });
        }
        //this.EmitNewActivity.emit(this.allActivities)
        this.hideModal();
    //     this.isPostActionSelected = false;
    }


    private deleteActivity() {
        if (this._activityID !== null) {
            this._insaChronService.deleteJobActivity(this._activityID)
                .subscribe(res => { 
                    if (this._jobID !== undefined && this._jobID !== null) {
                        this._insaChronService.getActivityByJobId(this._jobID)  
                        .subscribe(d => this.refreshActivitiesList(d)) }
                        
                    if(res.status === 204){
                        this.showMessage({
                            title: 'Delete Failed!',
                            message: `Please remove Activity "${this.selectedActivity.Description}" from the Flow before new delete attempt!`
                          });

                    }
                    })
        }
        this.isJobActivityForDeleteSelected = false;
        this.deleteAndUpdateGraph = true;
        this.emitDeleteAndUpdateGraph.emit(this.deleteAndUpdateGraph);
        this.deleteAndUpdateGraph = false;
    }

    showMessage({ title, message, onClose = null }) {
        const modalEl = $('#generic-editor-modal');
        modalEl.find('.modal-title').text(title);
        modalEl.find('.modal-body > p').text(message);
        modalEl.modal({ show: true });
        if (onClose) {
          $('#generic-editor-modal').on('hidden.bs.modal', function (e) {
            onClose();
          });
        }
      }

    addNewActivity() {
        this.isJobActivityAddSelected = true;
        this.selectedActivity = new ChronosActivitiesModel();
    }

    saveAndClose(selector) {
        this.isPostActionSelected = false;
        if (this.postActions !== null) {
            this._insaChronService.updateJobActivity(this.postActions).subscribe(
                /* d =>
                  { this._insaChronService.getActivityByJobId(this._jobID).subscribe()
                  }*/
            );
        }
        this.emitRenderGraphAgain.emit(true);
    }
    renderMermaid(event) {
        this.emitRenderGraphAgain.emit(true);
    }

    private onResize(event) {
        let activitiesGrid: kendo.ui.Grid = $("#ChronosJobActivitiesList").data("kendoGrid");
        if (activitiesGrid !== undefined) {
            activitiesGrid.options.height = $(".gridResize").height();
            activitiesGrid.resize();
        }
    }

    private InitKendoJobActivitiesGrid(columnDefs, griddata) {

        let dataSourceOptions: kendo.data.DataSourceOptions = {};
        dataSourceOptions.data = griddata;
        dataSourceOptions.schema = {
            model: {
                fields: {
                    ActivityID: { type: "number" },
                    JobID: { type: "number" },
                    ActivityTypeID: { type: "number" },
                    Description: { type: "string" },
                    TriggerOrder: { type: "number" },
                    MaxRepeatCount: { type: "number" },
                    RepeatDelayMinutes: { type: "number" }
                }
            }
        };

        let dataSource: kendo.data.DataSource = new kendo.data.DataSource(dataSourceOptions);
        columnDefs.push({ width:20,
            command: [
                {
                    name: "editActivityBtn",
                    //text: 'EDIT',
                
                    className: 'k-icon k-i-edit',
                    click: this.getActivityFromRow.bind(this)
                }
            ]
        });
        columnDefs.push({ width:20,
        command: [
                {
                    name: "deleteActivityBtn",
                    //text: 'DELETE',
                    className: 'k-icon k-i-delete',
                    click: this.getActivityFromRow.bind(this)
                }
            ]
        });

        columnDefs.push({ width:20,
        command: [
                {
                    name: "postActBtn",
                    className: 'k-icon k-i-folder-add',
                    title: "Post Actions",
                    //text: 'POST ACTIONS',
                    click: this.getActivityFromRow.bind(this)
                }
            ], hidden: (this._jobID == null && this._jobID == undefined)
        });

        let activitiesGrid: kendo.ui.Grid = $("#ChronosJobActivitiesList").data("kendoGrid");

        if (activitiesGrid === undefined) {
            let activitiesGridOptions: kendo.ui.GridOptions = {};
            activitiesGridOptions.dataSource = dataSource;
            activitiesGridOptions.filterable = false;
            //activitiesGridOptions.height = 130;
            activitiesGridOptions.sortable = true;
            activitiesGridOptions.selectable = true;
            activitiesGridOptions.reorderable = true;
            activitiesGridOptions.scrollable = true;
            activitiesGridOptions.noRecords = { template: SharedMethodsModule.noDataTemplate() };
            activitiesGridOptions.groupable = false; //BK confirmed it does not have to be groupable 150420/ removes "drag" text
            activitiesGridOptions.group = function (e) {
                if (e.groups !== undefined && e.groups !== null) {
                    let lastSavedGrouping = e.groups;
                    localStorage.setItem('jobActivitiesGridGrouping', JSON.stringify(lastSavedGrouping));
                }
            };
            activitiesGridOptions.sort = function (e) {
                if (e.sort !== undefined && e.sort !== null) {
                    let lastSavedSorting = e.sort;
                    localStorage.setItem('jobActivitiesGridSorting', JSON.stringify(lastSavedSorting));
                }
            };
            activitiesGridOptions.pageable = false;
            activitiesGridOptions.resizable = false;
            activitiesGridOptions.columns = columnDefs;

            activitiesGridOptions.dataBound = customGroupHeader.KendoGridDataBound;

            SharedMethodsModule.saveGridOptionsOnChange(activitiesGridOptions, this.gridName)
            const savedOptions = SharedMethodsModule.getSavedGridOptions(columnDefs, this.gridName)
            const combinedGridOptions = SharedMethodsModule.combineGridInitOptions(savedOptions, activitiesGridOptions)

            $("#ChronosJobActivitiesList").kendoGrid(combinedGridOptions);
            activitiesGrid = $("#ChronosJobActivitiesList").data("kendoGrid");

            if (savedOptions && savedOptions.dataSource) {
                $('#' + this.gridName).data('kendoGrid').dataSource.group(savedOptions.dataSource.group)
                $('#' + this.gridName).data('kendoGrid').dataSource.sort(savedOptions.dataSource.sort)
            }
        }
        else {
            activitiesGrid.setDataSource(dataSource);
        }
    }

    ngOnInit() {
        //kendo.ui.progress($(".activitiesGrid-loading"), this._appStateProvider.fetchingChronosJob);
    }

    ngAfterViewInit() {
        this.mermaidSelectedActivityIDSubject.subscribe(actID => {
            if (actID != undefined && actID != 0) {
                let activitiesGrid: kendo.ui.Grid = $("#ChronosJobActivitiesList").data("kendoGrid");
                if (activitiesGrid == undefined) return;

                let models = activitiesGrid.dataSource.data();
                let rowUID: string = "";

                models.forEach(model => {
                    if (model["ActivityID"] == actID) {
                        rowUID = model["uid"];
                        //acitvitiesGrid.select(this._mermaidSelectedActivityID );
                        var row = activitiesGrid.table.find("[data-uid=" + rowUID + "]");
                        activitiesGrid.select(row);

                        this._activityID = actID;
                        //open activity editor: 
                        this.isJobActivtySelected = true;
                        this.selectedActivity = activitiesGrid.dataItem(row);
                        var scrollContentOffset = activitiesGrid.element.find("tbody").offset().top;
                        var selectContentOffset = activitiesGrid.select().offset().top;
                        var distance = selectContentOffset - scrollContentOffset;
                        activitiesGrid.element.find(".k-grid-content").animate({
                            scrollTop: distance
                        }, 400);
                    }
                });
                this.mermaidVisible = true;
            }
        });

        this.mermaidAddNewActSubject.subscribe(addAct => {
            if (addAct) {
                this.addNewActivity();
                this.mermaidVisible = true;
            }
        });
    }

    ngOnDestroy() {
        this.mermaidSelectedActivityIDSubject.unsubscribe();
        this.mermaidAddNewActSubject.unsubscribe();
    }

    ngOnChanges() {
        /*if(this.finalActivityDataList.length < 1){
            if(this._activityTypes !== undefined){
                this.refreshActivitiesList(this._allJobActivities);
            }
        }*/
        if (this._activityTypes !== undefined && this.finalActivityDataList.length < 1) {
            this.refreshActivitiesList(this._allJobActivities);
        }
        this.priorites = this.prioritiesList;
    }
}


// WEBPACK FOOTER //
// ./app/insa-components/insa-cron/insa-job/insa-job-activities-list/job-activities.component.ts